<template>
  <!--編輯-->
  <v-dialog v-model="isVisible"
            persistent
            max-width="100%">
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation>
      <v-card>
        <v-card-title>
          <span class="title">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap column>
              <v-flex xs12 sm6 md4 v-for="col in dialogKeys" :key="col.value">
                <div v-if="col.value === 'birthday' || col.value === 'startDate' || col.value === 'endDate'">
                  <span class="subheading">{{col.text}}</span>
                  <date-time-tool
                    :dateInfo="editedItem[col.value]"
                    :disabled="false" :propertyKey="`birthday`">
                  </date-time-tool>
                </div>
<!--                <v-layout row wrap v-else-if="col.value === 'city'">-->

<!--                  <v-flex xs12>-->
<!--                    <span class="subheading">地址</span>-->
<!--                  </v-flex>-->
<!--                  <v-flex xs6>-->
<!--                    <v-autocomplete-->
<!--                      :items="cityList"-->
<!--                      placeholder="縣市"-->
<!--                      v-model="editedItem.city"-->
<!--                    ></v-autocomplete>-->
<!--                  </v-flex>-->
<!--                  <v-flex xs6>-->
<!--                    <v-autocomplete-->
<!--                      v-model="editedItem.area"-->
<!--                      :items="areaList[editedItem.city] ? areaList[editedItem.city] : []"-->
<!--                      :disabled="!editedItem.city || editedItem.city === ''"-->
<!--                      placeholder="鄉鎮區"-->
<!--                    ></v-autocomplete>-->
<!--                  </v-flex>-->
<!--                </v-layout>-->
                <v-text-field v-else-if="col.value === 'creditPrice'"
                              v-model="editedItem[col.value]" :label="col.text"
                              :rules="col.rules"
                              :disabled="isAdmin === false"
                              :required="col.required"></v-text-field>
                <div v-else-if="col.value === 'station'">
                  <span class="red--text subheading">已請示通過免查詢監理站的管轄區</span><br/>
                  <v-text-field
                    v-model="editedItem[col.value]" :label="col.text"
                    :rules="col.rules"
                    :disabled="col.disabled"
                    :required="col.required"></v-text-field>
                </div>

                <v-text-field v-else v-model="editedItem[col.value]" :label="col.text"
                              :rules="col.rules"
                              :disabled="col.disabled"
                              :required="col.required"></v-text-field>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
<!--          <v-btn color="red darken-1" v-if="isAdmin" flat @click="removeProfile">刪除</v-btn>-->
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="closeDialog">取消</v-btn>
          <v-btn color="blue darken-1" flat @click="save"
                 :loading="loading"
                 :disabled="loading">儲存</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import MobileDetect from 'mobile-detect';
  import dateTimeTool from "../components/dateTimeTool";
  const md = new MobileDetect(window.navigator.userAgent);

  export default {
    name: 'MortgageDialog',
    components: { dateTimeTool },
    props:{
      editedItem:Object,
      visible: Boolean,
    },
    data() {
      return {
        cityData: require('../assets/taiwan_city'),
        cityList: [],
        areaList: {},
        isMobile: md.phone(),
        loading: false,
        valid: true,
        dialog: false,
        editedIndex: -1,
        isVisible:false,
      }
    },
    watch:{
      isVisible(value){
        if(!value)
        {
          this.$emit('closeEvent');
        }
      }
    },
    created(){
      this.isVisible = this.visible;
      const now = new Date();
      const end = new Date(now.getFullYear() + 10, now.getMonth(), now.getDate());
      this.editedItem.startDate.year = `${now.getFullYear()-1911}`;
      this.editedItem.startDate.month = `${now.getMonth()+1 < 10 ? '0'+(now.getMonth()+1) : now.getMonth()+1}`;
      this.editedItem.startDate.day = `${now.getDate() < 10 ? '0'+(now.getDate()) : now.getDate()}`;
      this.editedItem.endDate.year = `${end.getFullYear()-1911}`;
      this.editedItem.endDate.month = `${end.getMonth()+1 < 10 ? '0'+(end.getMonth()+1) : end.getMonth()+1}`;
      this.editedItem.endDate.day = `${end.getDate() < 10 ? '0'+(end.getDate()) : end.getDate()}`;
      this.editedItem.carType = '普通重機';
      this.editedItem.creditPrice = 90000;
      this.editedItem.address = `${ this.editedItem.city}${ this.editedItem.area}${ this.editedItem.address}`;

      this.cityData.taiwan.forEach((city) => {
        this.cityList.push(city.city);
        this.areaList[city.city] = city.area;
      });
    },
    
    computed: {
      ...mapGetters(['getUserInfo']),
      formTitle() {
        return this.editedIndex === -1 ? '新增' : '編輯'
      },
      columnKeys() {
        let list =  [
          { value: 'delete', text: '刪除', sortable: false  ,required: false},
          { value: 'tools', text: '編輯', sortable: false  ,required: false},
          { value: 'print', text: '套印', sortable: false  ,required: false},
          { value: 'parentAgentName', text: '經銷', sortable: true  ,required: true},
          { value: 'memberId', text: '身分證/統一編號', sortable: false  ,required: true},
          { value: 'name', text: '車主名稱', sortable: true  ,required: true},
          { value: 'birthday', text: '出生日期', sortable: true  ,required: true},
          // { value: 'city', text: '縣市', sortable: false ,required: true, disabled:true , rules: [
          //     v => !!v || '請選擇縣市！',
          //   ],},
          { value: 'address', text: '戶籍地址', sortable: false ,required: true, disabled:false , rules: [
              v => !!v || '請填寫地址！',
            ],},
          { value: 'startDate', text: '契約生效日', sortable: true  ,required: true},
          { value: 'endDate', text: '契約終止日', sortable: true  ,required: true},
          { value: 'creditPrice', text: '期數x期付', sortable: true  ,required: true, disabled:true},
          { value: 'station', text: '監理所', sortable: true  ,required: true, disabled:true},
          { value: 'carId', text: '牌照號碼', sortable: true  ,required: true},
          { value: 'vendorId', text: '廠牌', sortable: true  ,required: true},
          { value: 'carYear', text: '出廠年份', sortable: true  ,required: true},
          { value: 'engineId', text: '引擎號碼/車身號碼', sortable: true  ,required: true},
          { value: 'carType', text: '牌照類別', sortable: true  ,required: true},
          { value: 'carEngineType', text: '型式', sortable: true  ,required: true},
          { value: 'createDate', text: '建立時間', sortable: true  ,required: false , disabled: true },
          { value: 'comment', text: '備註', sortable: false  ,required: false},
        ];
        if (this.isAdmin){
          return list;
        } else {
          return list.filter(m=>m.value !== 'delete');
        }
      },
      dialogKeys() {
        return this.columnKeys.filter(m=>m.value !== 'tools' && m.value !== 'delete' && m.value !== 'print');
      },
      isAdmin() {
        return this.getUserInfo.authority === 'admin';
      }
    },
    methods:{
      ...mapActions(['fetchMortgageList', 'saveMortgageData']),
      removeProfile(){
        console.log('removeProfile');
        this.$emit('removeProfile');
      },
      closeDialog(){
        console.log('closeDialog');
        this.$emit('closeDialog');
      },
      save(){
        console.log('save');
        this.saveEvent();
      },
      saveEvent() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.saveMortgageData(this.editedItem).then(error=>{
            this.loading = false;
            this.$emit('save');
          });
        }
      },
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MortgageDialog.vue